import {Actions} from '../../actions';
import {connect} from 'react-redux';
import NextSteps from "../../components/DiversityPE/NextSteps";

const mapStateToProps = (state, ownProps) => {
    return {
        company_permission: state.home.companyInformation.company_permission,
        diversitype: state.diversitype,
        home: state.home,
        improve: state.improve,
        ...ownProps
    };
};

export default connect(mapStateToProps, Actions)(NextSteps);
